export default "<app-navbar></app-navbar>\r\n<app-sidebar></app-sidebar>\r\n<div class=\"h-100\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n";